export default __webpack_public_path__ + "static/media/lunch.348a32b7.png";